import Mutations from '../../../store/data/mutations'
export default {
  namespaced: true,
  state: {
    billingPeriods: [],
    loadingBillingPeriods: false
  },
  mutations: Mutations
}
